/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { css, jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import { useContext, useState } from 'react';
import { WorkspaceContext } from '/views/workspace/workspaceContext';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import MultiSelect from 'components/multiselect';
import { TODO } from 'types';
import { filterProperties } from 'utilities/srsUtils';
import { Checkbox, H6 } from '@blueprintjs/core';
import { GenericObject } from 'interfaces/GenericObject';


interface Props {
	cardIndex: number;
	propertyName: string;
	label: string;
	endpointQuery: TODO;
	flags: TODO; 
	types: TODO; 
	minimumItems: any;
}

export function MultiPropertyCheckboxSelector({
	cardIndex,
	propertyName = 'columns',
	label,
	endpointQuery,
	flags = [],
	types = [],
	minimumItems=1
}: Props) {
	const {
		state: {
			explorer: { selectedDefinitionName },
		},
		dispatch,
	} = useContext(WorkspaceContext);

	// only allows a subset of properties to be filtered (based on flags and types)
	const filteredProperties = filterProperties(selectedDefinitionName, flags, types).map(property => property.name);

	//Use selectedColumnNames to update endpoint with correct values.
	const [selectedColumnNames, setSelectedColumns] = useState<GenericObject<boolean>>(endpointQuery?.options?.[propertyName].reduce((coll,d)=>(coll[d]=true,coll),{}));

	const _toggleAll = e => {
		const isChecked = e.target.checked;
		// create copy of options object
		const newEndpointQuery = JSON.parse(JSON.stringify(endpointQuery));

		if(isChecked) {
			//grab all filteredProperties and use them
			newEndpointQuery.options[propertyName] = [...filteredProperties];
		}
		else {
			//use the first entries that are marked true. In theory selectedColumnNames will always have, at a minimum, minimumItems
			//	marked as true. So the .slice() will always return an array with length === minimumItems
			newEndpointQuery.options[propertyName] = Object.entries(selectedColumnNames)
				.filter(([,v]) => v)
				.map(([k,_]) => k)
				.slice(0, minimumItems);
		}

		newEndpointQuery.options[propertyName].sort();

		//newEndpointQuery has the most upto date and more correct version of data. Set our local state to match.
		//(case when the two won't already match: when setting all boxes to false, the newEndpointQuery will still have at
		// least one entry, where as selectedColumnNames will have all entries set to false)
		setSelectedColumns(newEndpointQuery.options?.[propertyName].reduce((coll,d)=>(coll[d]=true,coll),{}));
		dispatch(WorkspaceActionCreator.options(cardIndex, newEndpointQuery));
	}

	const _onChange = p => {
		const value = p.target.checked;
		const key = p.target.getAttribute("data-value");
		selectedColumnNames[key] = value;

		// create copy of options object
		const newEndpointQuery = JSON.parse(JSON.stringify(endpointQuery));
		newEndpointQuery.options[propertyName] = Object.entries(selectedColumnNames)
			.filter(([,v]) => v)
			.map(([k,_]) => k);
		//If less than minimumItems don't allow it to be turned off
		if(newEndpointQuery.options[propertyName].length < minimumItems)
			newEndpointQuery.options[propertyName].push(key);
		newEndpointQuery.options[propertyName].sort();

		//newEndpointQuery has the most upto date and more correct version of data. Set our local state to match.
		//(case when the two won't already match: when setting all boxes to false, the newEndpointQuery will still have at
		// least one entry, where as selectedColumnNames will have all entries set to false)
		setSelectedColumns(newEndpointQuery.options?.[propertyName].reduce((coll,d)=>(coll[d]=true,coll),{}));
		dispatch(WorkspaceActionCreator.options(cardIndex, newEndpointQuery));
	}

	const numberOfSelectedColumns = Object.values(selectedColumnNames).filter(d => d).length;
	return (
		<div css={rootCss}>
			<H6>{label}</H6>
			<div className="contents-wrapper">
				<Checkbox
					checked={numberOfSelectedColumns === filteredProperties.length}
					label="Select All"
					onChange={_toggleAll}
					indeterminate={numberOfSelectedColumns !== filteredProperties.length && numberOfSelectedColumns > 0}
				/>
				<div style={{overflow: "auto"}}>
				{
					filteredProperties.map(d => (
						<Checkbox key={d} checked={selectedColumnNames[d] || false} label={d} onChange={_onChange} data-value={d} />
					))
				}
				</div>
			</div>
		</div>
	)
}


const rootCss = css`
	display: flex;
	flex-direction: column;	
	/*max-height: 100%;*/
	overflow: hidden;
	& .contents-wrapper 
		{
			overflow: auto;
		}
`;

